import { useMutation } from '@tanstack/react-query';
import { type SendVerificationCodeLocale } from '../../infrastructure/api/invitation.api.repository';
import { sendVerificationCode } from '../../infrastructure/api/invitation.api.repository';

export function useSendVerificationCode() {
  const mutation = useMutation({
    mutationFn: ({
      token,
      locale,
    }: {
      token: string;
      locale?: SendVerificationCodeLocale;
    }) => sendVerificationCode(token, locale),
  });

  return {
    sendCode: (token: string, locale?: SendVerificationCodeLocale) =>
      mutation.mutate({ token, locale }),
    sendCodeAsync: (token: string, locale?: SendVerificationCodeLocale) =>
      mutation.mutateAsync({ token, locale }),
    isSending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
}
